"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightSplitMenuButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _flyout = require("../../../flyout");
var _menu = require("../../../menu");
var _useFocusElement = require("../../hooks/useFocusElement");
var _RightSplitButton = require("../../styled/RightSplitButton");
var _toolbarTheme = require("../../styled/toolbarTheme");
var _RightSplitButtonClickWrapper = require("./RightSplitButtonClickWrapper");
const RightSplitMenuButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    isDisabled,
    isChecked = false,
    isHovered,
    menuId,
    label,
    targetRef,
    onBlur,
    onFocus,
    onMenuTrigger,
    onMouseEnter: providedOnMouseEnter,
    onClick: providedOnClick,
    menuRef,
    ...rest
  } = _ref;
  const localMenuRef = (0, _react.useRef)(null);
  const internalMenuRef = (0, _lodestarUtils.useForkRef)(localMenuRef, menuRef);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    isOpen,
    onCloseRequested,
    onOpenRequested
  } = (0, _menu.useMenuOpenState)();
  const focusProps = (0, _useFocusElement.useFocusElement)({
    targetRef: ref,
    onFocus,
    onBlur,
    onKeyDown: rest.onKeyDown
  });
  const onMenuClosing = () => {
    onCloseRequested();
    onMenuTrigger && onMenuTrigger(false);
  };
  const {
    getMenuProps,
    getTargetHTMLProps
  } = (0, _menu.useMenu)({
    style: {
      maxHeight: "40vh"
    },
    onOpenRequested: () => {
      onOpenRequested();
      onMenuTrigger && onMenuTrigger(true);
    },
    onCloseRequested: onMenuClosing,
    isOpen,
    targetRef: focusProps.ref,
    placement: "bottom",
    id: menuId,
    menuRef: internalMenuRef
  });
  const targetMenuProps = getTargetHTMLProps({
    onBlur: focusProps.onBlur,
    onFocus: focusProps.onFocus,
    onMouseEnter: providedOnMouseEnter,
    onClick: providedOnClick,
    "aria-label": label,
    tabIndex: focusProps.tabIndex,
    onKeyDown: evt => {
      focusProps.onKeyDown?.(evt);
      switch (evt.key) {
        case "ArrowLeft":
        case "ArrowRight":
        case "Tab":
          onMenuClosing();
          break;
        default:
          break;
      }
    }
  });
  return /*#__PURE__*/_react.default.createElement(_flyout.ClickAwayListener, {
    onClickAway: onMenuClosing
  }, /*#__PURE__*/_react.default.createElement(_RightSplitButtonClickWrapper.RightSplitButtonClickWrapper, {
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement(_RightSplitButton.RightSplitButton, (0, _extends2.default)({}, rest, {
    label: label,
    isChecked: isChecked,
    isHovered: isHovered,
    isOpen: isOpen,
    isDisabled: isDisabled,
    iconAfter: (0, _toolbarTheme.getToolbarDropdownArrowIconTheme)(themeMode),
    toolbarButtonType: "ToolbarRightSplitButton",
    themeMode: themeMode
  }, targetMenuProps)), /*#__PURE__*/_react.default.createElement(_menu.Menu, (0, _extends2.default)({}, getMenuProps({
    "aria-label": label,
    offset: {
      distance: 4
    }
  }), {
    targetElement: targetRef
  }), children)));
});
exports.RightSplitMenuButton = RightSplitMenuButton;
RightSplitMenuButton.displayName = "RightSplitMenuButton";
//# sourceMappingURL=RightSplitMenuButton.js.map